import { post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useAuthenticate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("user/authenticate", data, false);
    }, options);
};